import { render, staticRenderFns } from "./HotGoods.vue?vue&type=template&id=d8189032&scoped=true"
import script from "./HotGoods.vue?vue&type=script&lang=js"
export * from "./HotGoods.vue?vue&type=script&lang=js"
import style0 from "./HotGoods.vue?vue&type=style&index=0&id=d8189032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8189032",
  null
  
)

export default component.exports